/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".confirm[_ngcontent-%COMP%]{width:94px;height:33px;border-radius:2px}.padding-17-0[_ngcontent-%COMP%]{padding:17px 0}.text-align-centre[_ngcontent-%COMP%]{text-align:center}\n/*# sourceMappingURL=confirm-dialog.component.css.map*/"];
export { styles as styles };
